import { Tag as TagIcon, X } from "lucide-react";
import { type KeyboardEvent, useState } from "react";

interface Props {
  tags: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

export function TagChips({ tags, onChange, disabled }: Props) {
  const [input, setInput] = useState("");

  function add(name: string) {
    const v = name.trim();
    if (!v) return;
    if (tags.some((t) => t.toLowerCase() === v.toLowerCase())) {
      setInput("");
      return;
    }
    onChange([...tags, v]);
    setInput("");
  }

  function remove(name: string) {
    onChange(tags.filter((t) => t !== name));
  }

  function handleKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(input);
    } else if (e.key === "Backspace" && input === "" && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-1 text-xs">
      <TagIcon className="h-3 w-3 text-zinc-500" />
      {tags.map((t) => (
        <span
          key={t}
          className="group inline-flex items-center gap-1 rounded-full border border-zinc-700 bg-zinc-900 px-2 py-0.5 text-zinc-200"
        >
          {t}
          {!disabled && (
            <button
              onClick={() => remove(t)}
              className="text-zinc-500 hover:text-red-400"
              title="Tag entfernen"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </span>
      ))}
      {!disabled && (
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKey}
          onBlur={() => add(input)}
          placeholder="+ Tag"
          className="w-20 border-b border-transparent bg-transparent px-1 py-0.5 text-xs text-zinc-400 placeholder-zinc-600 focus:border-zinc-700 focus:outline-none"
        />
      )}
    </div>
  );
}
